import { Component, EventEmitter, OnInit, Input, Output, ViewChild } from '@angular/core';
import { Router }            from '@angular/router';
import {Message, OverlayPanel, SelectItem} from 'primeng/primeng';

import * as ent from '../../entities/index'
import * as enums from '../../enums/index'
import * as filters from '../../filters/index'
import * as serv from '../../services/index'
import * as util from '../../util/index'

//components
import { BaseRequestComponent }                from '../../baseclasses/BaseRequest.component';
import {UserInfoComponent} from '../../components/ControlGroups/UserInfo.component';
import {CompletionDetailsComponent} from '../../components/ControlGroups/CompletionDetails.component';
import {GeneralDetailsComponent} from '../../components/ControlGroups/GeneralDetails.component';
import {AddressComponent} from '../../components/ControlGroups/Address.component';
import {ContactDetailsComponent} from '../../components/ControlGroups/ContactDetails.component';
import {SuppressStatusComponent} from '../../components/ControlGroups/SuppressStatus.component';
import {PricingComponent} from '../../components/ControlGroups/Pricing.component';
import {SalesAndDeliveryDetailsComponent} from '../../components/ControlGroups/SalesAndDeliveryDetails.component';
import {BillingAddressComponent} from '../../components/ControlGroups/BillingAddress.component';
import { StatementDetailsComponent } from '../ControlGroups/StatementDetails.component';
import {NotesComponent} from '../../components/ControlGroups/Notes.component';
import {RequestHeaderComponent} from '../../components/Controls/RequestHeader.component';
import {ChangePhoneNumberDialogComponent} from '../../components/Employees/ChangePhoneNumberDialog.component';

//constants
import { Constants }         from '../../constants/Constants';

@Component({
  selector: 'my-createmaintain-customer-request',
  templateUrl: './CreateMaintainCustomerRequest.component.html'
})
export class CreateMaintainCustomerRequestComponent extends BaseRequestComponent {

    userInfo: ent.UserInfo;
    requestToSave: ent.Request;
    displayCannotSaveUnsuppressWithOwnerChange: boolean;
    

    @ViewChild(UserInfoComponent) userInfoComponent: UserInfoComponent;
    @ViewChild(CompletionDetailsComponent) completionDetailsComponent: CompletionDetailsComponent;
    @ViewChild(GeneralDetailsComponent) generalDetailsComponent: GeneralDetailsComponent;
    @ViewChild(AddressComponent) addressComponent: AddressComponent;
    @ViewChild(ContactDetailsComponent) contactDetailsComponent: ContactDetailsComponent;
    @ViewChild(StatementDetailsComponent) statementDetailsComponent: StatementDetailsComponent;
    
    //@ViewChild(SuppressStatusComponent) suppressStatusComponent: SuppressStatusComponent;
    //@ViewChild(PricingComponent) pricingComponent: PricingComponent;
    // @ViewChild(SalesAndDeliveryDetailsComponent) salesAndDeliveryComponent: SalesAndDeliveryDetailsComponent;
    //@ViewChild(BillingAddressComponent) billingAddressComponent: BillingAddressComponent;
    @ViewChild(NotesComponent) notesComponent: NotesComponent;
    @ViewChild(RequestHeaderComponent) requestHeaderComponent: RequestHeaderComponent;
    @ViewChild(ChangePhoneNumberDialogComponent) changePhoneNumberDialogComponent: ChangePhoneNumberDialogComponent;

    constructor() 
    {
        super();
    }

    ngOnInit(): void {
        if (!this.authenticationService.checkLoginStatus())
        {
            this.router.navigate(['login']);
        }

        this.userInfo = this.authenticationService.getUserInfo();
        
    }

    getRequestTypeID(){
        return enums.RequestTypeEnum.MaintainCustomer;
    }


    onSaveClick(event: any){
        var val = this.validateBeforeSave();
        if (!val){
            return;
        }

        this.requestToSave = {
            ID: this.requestID,
            RequestTypeID: enums.RequestTypeEnum.MaintainCustomer,
            RequestStatusID: this.request ? this.request.RequestStatusID : enums.RequestStatusEnum.Open,
            GeneralInfo: this.generalDetailsComponent.generalInfo,
            // ContactInfos: [this.contactDetailsComponent.contactInfo],
            ContactInfos: this.contactDetailsComponent.contactGridComponent.records,
            StatementInfo: this.statementDetailsComponent.statementInfo,
            //PricingInfo: this.pricingComponent.pricingInfo,
            //SalesAndDeliveryInfo: this.salesAndDeliveryComponent.salesAndDeliveryInfo,
            //BillingInfo: this.billingAddressComponent.billingInfo,
            //SuppressInfo: this.suppressStatusComponent.suppressInfo,
            OtherInfo: this.notesComponent.otherInfo,
            EmployeeID: this.userInfoComponent.userInfo.Employee.ID, 
            SalesOfficeID: this.userInfoComponent.userInfo.SalesOffice.ID, 
            PhoneNumber: this.userInfoComponent.userInfo.Employee.PhoneNumber,
            RequestDate: new Date()
        };

        util.RequestUtil.LoadCompletionDetails(this.requestToSave, this.completionDetailsComponent);
        
        if (this.userInfoComponent.request.PhoneNumber){
            this.requestToSave.PhoneNumber = this.userInfoComponent.request.PhoneNumber;
        }
        //this.requestToSave.VendPackageLineItems = this.pricingComponent.vendPackageLineItemGrid.lineItems;
        this.requestToSave.Addresses = [];

        if (util.AddressUtil.isAddressPopulated(this.addressComponent.address)){
            this.requestToSave.Addresses.push(this.addressComponent.address);
        }
        
        // if (util.AddressUtil.isAddressPopulated(this.billingAddressComponent.billingInfo.Address)){
        //     this.requestToSave.Addresses.push(this.billingAddressComponent.billingInfo.Address);
        // }

        // this.requestToSave.RequestDays = RequestUtil.LoadRequestDays(this.requestToSave, this.salesAndDeliveryComponent.deliveryDaysDayOfWeekMultiSelectComponent, DayType.Delivery);
        // this.requestToSave.RequestDays = RequestUtil.LoadRequestDays(this.requestToSave, this.salesAndDeliveryComponent.callDaysDayOfWeekMultiSelectComponent, DayType.Call);

        this.changePhoneNumberDialogComponent.promptToUpdatePassword(this.requestToSave.PhoneNumber, this.userInfoComponent.userInfo.Employee.PhoneNumber, this.userInfoComponent.userInfo.Employee.ID);

    }
    onYes(event: ent.Response){
        this.requestHeaderComponent.handleResponse(event);
        this.saveRequest(this.requestToSave);
    }

    onNo(event: any){
        this.saveRequest(this.requestToSave);
    }

    onCancel(event: any){
        //do nothing
    }

    validateBeforeSave(): boolean{
        var val: boolean = true;

        // if (this.suppressStatusComponent.suppressInfo.UnsuppressCustomer && this.suppressStatusComponent.suppressInfo.OwnershipChange){
        //     this.displayCannotSaveUnsuppressWithOwnerChange = true;
        //     val = false;
        // }
        return val;
    }
    onHideCannotSaveUnsuppressWithOwnerChangeDialog(event: any){
        this.displayCannotSaveUnsuppressWithOwnerChange = false;
    }


}